export default "__VITE_ASSET__BWNS5y4c__"